import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StreetviewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"streetview"}/>
}
